// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ChevronDown } from "lucide-react";

// components
import Config from "Config";

// selectors
import { getCurrentEnvironment, getUserAvailableEnvironments } from "Selectors/app";

// actions
import { changeEnvironment } from "Actions/app";

// styles
import css from "./EnvironmentSwitcher";

class EnvironmentSwitcher extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		height: PropTypes.number,
		changeEnvironment: PropTypes.func.isRequired,
		currentEnvironment: PropTypes.object.isRequired,
		userEnvironments: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {
		className: "",
		height: 30,
	};

	state = {
		isOpen: false,
	};

	componentDidMount = () => {
		this._ignoreBlur = false;
	};

	setIgnoreBlur = (value) => {
		this._ignoreBlur = value;
	};

	handleOpenOptions = () => {
		this.setState({ isOpen: true }, () => {
			window.addEventListener("click", this.handleCloseOptions);
		});
	};

	handleCloseOptions = () => {
		if (this._ignoreBlur) {
			return;
		}

		this.setState({ isOpen: false });
	};

	handleEnvironmentChange = (environment) => {
		this.props.changeEnvironment(environment);
		this.handleCloseOptions();
		this.setState({ isOpen: false });
	};

	render = () => {
		const { isOpen } = this.state;
		const { className, currentEnvironment, userEnvironments, height } = this.props;

		const otherEnvironments = Config.environments
			.filter((environment) => environment.name !== "dev")
			.filter((environment) => environment.name !== currentEnvironment.name)
			.filter((environment) => userEnvironments.contains(environment.name));

		return (
			<div
				className={`${css.environmentSwitcher} ${className}`}
				onMouseLeave={() => this.setIgnoreBlur(false)}
				onMouseEnter={() => this.setIgnoreBlur(true)}
			>
				<div
					onClick={this.handleOpenOptions}
					style={{ height, lineHeight: `${height}px` }}
					className={css.currentEnvironment}
				>
					{currentEnvironment.label}

					{otherEnvironments.length > 0 ? (
						<div className={css.svgIcon}>
							<ChevronDown size={16} />
						</div>
					) : null}
				</div>

				{isOpen && otherEnvironments.length > 0 ? (
					<div style={{ top: height + 5 }} className={css.environmentChoices}>
						{otherEnvironments.map((environment) => (
							<div
								key={environment.name}
								onClick={() => this.handleEnvironmentChange(environment.name)}
								className={css.option}
							>
								{environment.label}
							</div>
						))}
					</div>
				) : null}
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	currentEnvironment: getCurrentEnvironment(state),
	userEnvironments: getUserAvailableEnvironments(state),
});

const mapDispatchToProps = (dispatch) => ({
	changeEnvironment: (environmentName) => dispatch(changeEnvironment(environmentName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnvironmentSwitcher);
